import script from "./check-bind-sn.vue?vue&type=script&lang=ts&setup=true"
export * from "./check-bind-sn.vue?vue&type=script&lang=ts&setup=true"

import "./check-bind-sn.vue?vue&type=style&index=0&id=0863ac36&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0863ac36"]])

export default __exports__